import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import Modal from '../components/Modal';
import apiService from '../services/apiService';

const specialtyOptions = [
    { value: 'poultry_care', label: 'Poultry Care' },
    { value: 'cattle_health', label: 'Cattle Health' },
    { value: 'veterinary_surgery', label: 'Veterinary Surgery' },
    { value: 'animal_nutrition', label: 'Animal Nutrition' },
    { value: 'livestock_management', label: 'Livestock Management' },
    { value: 'disease_control', label: 'Disease Control' },
    { value: 'farm_vaccination', label: 'Farm Vaccination' },
    { value: 'poultry_diagnostics', label: 'Poultry Diagnostics' },
    { value: 'avian_diseases', label: 'Avian Diseases Specialist' },
    { value: 'hatchery_management', label: 'Hatchery Management' },
    { value: 'broiler_management', label: 'Broiler Management' },
    { value: 'layer_management', label: 'Layer Farm Management' },
    { value: 'biosecurity_management', label: 'Biosecurity Management' },
    { value: 'feed_formulation', label: 'Feed Formulation' },
    { value: 'parasite_control', label: 'Parasite Control' },
    { value: 'antibiotic_stewardship', label: 'Antibiotic Stewardship' },
    { value: 'reproductive_health', label: 'Reproductive Health' },
    { value: 'egg_quality_management', label: 'Egg Quality Management' },
    { value: 'farm_sanitation', label: 'Farm Sanitation & Hygiene' },
    { value: 'environmental_management', label: 'Poultry Environment Management' },
    { value: 'heat_stress_management', label: 'Heat Stress Management' },
    { value: 'poultry_welfare', label: 'Animal Welfare (Poultry)' },
    { value: 'veterinary_consultation', label: 'General Veterinary Consultation' },
];

const DoctorBookingPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useContext(AuthContext);
  const doctor = state?.doctor || {};
  console.log("booking page doctor", doctor);
  const [currentStep, setCurrentStep] = useState(1);
  const [consultationType, setConsultationType] = useState('remote');
  const [selectedDate, setSelectedDate] = useState(new Date('2025-06-18T15:15:00+05:00')); // 3:15 PM PKT, June 18, 2025
  const [selectedTime, setSelectedTime] = useState('');
  const [symptoms, setSymptoms] = useState('');
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

  const [slots, setSlots] = useState({
    '9:00 am': 0,  // Past time, unavailable
    '10:00 am': 0, // Past time, unavailable
    '11:00 am': 0, // Past time, unavailable
    '12:00 pm': 0, // Past time, unavailable
    '1:00 pm': 0,  // Past time, unavailable
    '2:00 pm': 0,  // Past time, unavailable
    '3:00 pm': 0,  // Past time, unavailable
    '4:00 pm': 1,  // Future time, available
    '5:00 pm': 1,
    '6:00 pm': 1,
    '7:00 pm': 1,
    '8:00 pm': 1,
  });
  const [clinics] = useState([
    { id: 1, name: 'Vitalplus Clinic', location: 'Scottsdale, AZ' },
    { id: 2, name: 'Ander Clinic', location: 'Las Vegas, USA - 12546 New York' },
  ]);

  useEffect(() => {
    if (!isAuthenticated() && !isLoginModalOpen) {
      setIsLoginModalOpen(true);
    }
  }, [isAuthenticated, isLoginModalOpen]);

  const handleNext = () => {
    if (currentStep === 1 && !consultationType) return;
    if (currentStep === 2 && !selectedTime) return;
    if (currentStep === 3 && !symptoms) return;
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleBookAppointment = async () => {
    if (!isAuthenticated()) {
      setIsLoginModalOpen(true);
      return;
    }

    const bookingDateTime = new Date(selectedDate);
    const [hour, period] = selectedTime.split(' ');
    const hourNum = parseInt(hour.split(':')[0]);
    bookingDateTime.setHours(period.includes('pm') && hourNum !== 12 ? hourNum + 12 : hourNum);
    bookingDateTime.setMinutes(0);

    try {
      const response = await apiService.post('/consultations', {
        userId: user?.id,
        specialistId: doctor?._id,
        symptoms,
        consultationType,
        bookingDateTime,
      });
      console.log('Consultation created:', response);
      setBookingDetails({
        consultationType,
        date: selectedDate.toLocaleDateString(),
        time: selectedTime,
        doctorName: doctor.name || 'Dr. Ruby Perrin',
        patientName: user?.name || 'Logged-in User',
        symptoms: symptoms || 'No symptoms provided',
        total: `$${feeAmount.toFixed(2)}`,
      });
      setIsConfirmationModalOpen(true);
    } catch (error) {
      console.error('Error creating consultation:', error);
    }
  };

  const handleLoginClose = () => {
    setIsLoginModalOpen(false);
    navigate('/login');
  };

  const handleConfirmationClose = () => {
    setIsConfirmationModalOpen(false);
    navigate('/');
  };

  const feeAmount = doctor.fees != null ? doctor.fees : 0;

  // Map specialty values to labels
  const getSpecialtyLabels = (specialties) => {
    if (!Array.isArray(specialties) || specialties.length === 0) {
      return ['No specialties listed'];
    }
    return specialties.map((value) => {
      const specialty = specialtyOptions.find((option) => option.value === value);
      return specialty ? specialty.label : value;
    });
  };

  // Render star rating
  const renderStarRating = (rating) => {
    const maxStars = 5;
    const validRating = typeof rating === 'number' && rating >= 0 && rating <= maxStars ? rating : 0;
    const fullStars = Math.floor(validRating);
    const halfStar = validRating % 1 >= 0.5 ? 1 : 0;
    const emptyStars = maxStars - fullStars - halfStar;

    return (
      <div className="flex items-center">
        {[...Array(fullStars)].map((_, i) => (
          <svg key={`full-${i}`} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.97a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.357 2.44a1 1 0 00-.364 1.118l1.286 3.97c.3.921-.755 1.688-1.54 1.118l-3.357-2.44a1 1 0 00-1.175 0l-3.357 2.44c-.784.57-1.838-.197-1.54-1.118l1.286-3.97a1 1 0 00-.364-1.118L2.73 9.397c-.784-.57-.38-1.81.588-1.81h4.15a1 1 0 00.95-.69l1.286-3.97z" />
          </svg>
        ))}
        {halfStar === 1 && (
          <svg className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.97a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.357 2.44a1 1 0 00-.364 1.118l1.286 3.97c.3.921-.755 1.688-1.54 1.118l-3.357-2.44a1 1 0 00-.588 0V2.927z" />
          </svg>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <svg key={`empty-${i}`} className="w-4 h-4 sm:w-5 sm:h-5 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.97a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.357 2.44a1 1 0 00-.364 1.118l1.286 3.97c.3.921-.755 1.688-1.54 1.118l-3.357-2.44a1 1 0 00-1.175 0l-3.357 2.44c-.784.57-1.838-.197-1.54-1.118l1.286-3.97a1 1 0 00-.364-1.118L2.73 9.397c-.784-.57-.38-1.81.588-1.81h4.15a1 1 0 00.95-.69l1.286-3.97z" />
          </svg>
        ))}
        <span className="ml-2 text-gray-600 text-xs sm:text-sm">{validRating > 0 ? validRating.toFixed(1) : 'No ratings yet'}</span>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8 sm:py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-4 sm:mb-6">Book Your Appointment</h1>
        <div className="text-sm text-gray-600 text-center mb-6 sm:mb-8">Home &gt; Book Appointment</div>
        <div className="flex justify-center mb-6 sm:mb-8">
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 bg-white shadow-lg rounded-lg p-3 sm:p-4">
            {[1, 2, 3, 4].map((step) => (
              <div key={step} className="flex items-center gap-2 sm:gap-3">
                <div
                  className={`w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full text-sm font-medium transition-all duration-300 ${
                    currentStep >= step ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-600'
                  }`}
                >
                  {step}
                </div>
                {step < 4 && <div className="hidden sm:block h-0.5 w-8 sm:w-12 bg-gray-200"></div>}
                <span
                  className={`text-xs sm:text-sm ${
                    currentStep >= step ? 'text-gray-900 font-semibold' : 'text-gray-500'
                  }`}
                >
                  {['Appointment Type', 'Date & Time', 'Details', 'Confirmation'][step - 1]}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-2xl p-4 sm:p-6 max-w-4xl mx-auto">
          <div className="flex flex-col gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <img
                src={doctor.profilePicture ? `${BASE_URL}${doctor.profilePicture}` : 'https://via.placeholder.com/150'}
                alt={doctor.name}
                className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-full border-4 border-indigo-100"
              />
              <div className="flex flex-col sm:flex-row sm:justify-between w-full">
                <div className="text-center sm:text-left">
                  <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{doctor.name || 'Dr. Ruby Perrin'}</h2>
                  <p className="text-indigo-600 text-sm sm:text-base">{doctor.specialty || 'Veterinarian'}</p>
                  <p className="text-gray-600 text-xs sm:text-sm">{doctor.address }</p>
                </div>
                <div className="mt-2 sm:mt-0 sm:text-right">
                  {renderStarRating(doctor.rating)}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
              <div>
                <p className="text-gray-700 text-xs sm:text-sm font-semibold">Specialties:</p>
                <div className="flex flex-wrap gap-2 mt-1">
                  {getSpecialtyLabels(doctor.specialties).map((label, index) => (
                    <span
                      key={index}
                      className="inline-block bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded-full"
                    >
                      {label}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-gray-700 text-xs sm:text-sm font-semibold">Fees:</p>
                <p className="text-gray-600 text-xs sm:text-sm">£{doctor.fees?.toFixed(2) || '0.00'}</p>
              </div>
              <div>
                <p className="text-gray-700 text-xs sm:text-sm font-semibold">Experience:</p>
                <p className="text-gray-600 text-xs sm:text-sm">
                  {doctor.experience ? `${doctor.experience} years` : 'Not specified'}
                </p>
              </div>
              <div>
                <p className="text-gray-700 text-xs sm:text-sm font-semibold">Availability:</p>
                <p className="text-gray-600 text-xs sm:text-sm">
                  {doctor.availability || 'Not specified'}
                </p>
              </div>
              <div className="sm:col-span-2">
                <p className="text-gray-700 text-xs sm:text-sm font-semibold">About:</p>
                <p className="text-gray-600 text-xs sm:text-sm mt-1 leading-relaxed">
                  {doctor.bio || 'No bio provided.'}
                </p>
              </div>
            </div>
          </div>

          {currentStep === 1 && (
            <div className="p-4 bg-gray-50 rounded-lg shadow-sm">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">Consultation Type</h3>
              <select
                value={consultationType}
                onChange={(e) => setConsultationType(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-gray-700 text-sm sm:text-base"
              >
                <option value="remote">Remote</option>
                <option value="on-site">On-site</option>
              </select>
            </div>
          )}

          {currentStep === 2 && (
            <div className="p-4 bg-gray-50 rounded-lg shadow-sm">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">Date & Time</h3>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <div className="w-full sm:w-1/2">
                  <Calendar
                    onChange={setSelectedDate}
                    value={selectedDate}
                    className="w-full border border-gray-300 rounded-lg p-2 text-gray-700 text-sm"
                    minDate={new Date('2025-06-18T15:15:00+05:00')} // 3:15 PM PKT, June 18, 2025
                  />
                </div>
                <div className="w-full sm:w-1/2">
                  <h4 className="text-sm sm:text-md font-semibold text-gray-700 mb-2">Available Slots</h4>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    {Object.entries(slots).map(([time, available]) => (
                      <button
                        key={time}
                        onClick={() => setSelectedTime(time)}
                        className={`p-2 rounded-md text-sm ${
                          selectedTime === time
                            ? 'bg-indigo-600 text-white'
                            : available === 0
                            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                            : 'bg-gray-100 text-gray-700 hover:bg-indigo-100'
                        } transition duration-200`}
                        disabled={available === 0}
                      >
                        {time}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {currentStep === 3 && (
            <div className="p-4 bg-gray-50 rounded-lg shadow-sm">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">Details</h3>
              <textarea
                value={symptoms}
                onChange={(e) => setSymptoms(e.target.value)}
                placeholder="Describe your symptoms..."
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 h-32 sm:h-40 text-gray-700 text-sm sm:text-base"
              />
            </div>
          )}

          {currentStep === 4 && (
            <div className="p-4 bg-gray-50 rounded-lg shadow-sm">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">Confirmation</h3>
              <div className="space-y-2 text-gray-700 text-sm sm:text-base">
                <p>Consultation Type: <span className="font-semibold">{consultationType}</span></p>
                <p>Date: <span className="font-semibold">{selectedDate.toLocaleDateString()}</span></p>
                <p>Time: <span className="font-semibold">{selectedTime}</span></p>
                <p>Doctor: <span className="font-semibold">{doctor.name || 'Dr. Ruby Perrin'}</span></p>
                <p>Patient: <span className="font-semibold">{user?.name || 'Logged-in User'}</span></p>
                <p>Symptoms: <span className="font-semibold">{symptoms || 'No symptoms provided'}</span></p>
                <p>Total: <span className="font-semibold text-green-600">${feeAmount.toFixed(2)}</span></p>
              </div>
              <button
                onClick={() => navigate('/')}
                className="mt-6 w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition duration-200 font-semibold text-sm sm:text-base"
              >
                Finish
              </button>
            </div>
          )}

          <div className="flex flex-col sm:flex-row justify-between gap-4 mt-6">
            <button
              onClick={handleBack}
              className="bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition duration-200 disabled:opacity-50 text-sm sm:text-base"
              disabled={currentStep === 1}
            >
              Back
            </button>
            {currentStep < 4 ? (
              <button
                onClick={handleNext}
                className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition duration-200 font-semibold text-sm sm:text-base"
              >
                {currentStep === 1 ? 'Select Date & Time' : currentStep === 2 ? 'Add Details' : 'Confirm'}
              </button>
            ) : (
              <button
                onClick={handleBookAppointment}
                className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition duration-200 font-semibold text-sm sm:text-base"
                disabled={!selectedTime || !symptoms}
              >
                Confirm Booking
              </button>
            )}
          </div>
        </div>

        <Modal
          isOpen={isLoginModalOpen}
          onClose={handleLoginClose}
          title="Login Required"
          className="bg-white rounded-lg shadow-xl p-4 sm:p-6 max-w-md mx-auto"
        >
          <p className="text-gray-700 text-sm sm:text-base">Please log in to book an appointment.</p>
          <button
            onClick={handleLoginClose}
            className="mt-4 w-full bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition duration-200 font-semibold text-sm sm:text-base"
          >
            Go to Login
          </button>
        </Modal>

        <Modal
          isOpen={isConfirmationModalOpen}
          onClose={handleConfirmationClose}
          title="Booking Confirmed"
          className="bg-white rounded-lg shadow-xl p-4 sm:p-6 max-w-md mx-auto"
        >
          <div className="space-y-2 text-gray-700 text-sm sm:text-base">
            <p>Consultation Type: <span className="font-semibold">{bookingDetails?.consultationType}</span></p>
            <p>Date: <span className="font-semibold">{bookingDetails?.date}</span></p>
            <p>Time: <span className="font-semibold">{bookingDetails?.time}</span></p>
            <p>Doctor: <span className="font-semibold">{bookingDetails?.doctorName}</span></p>
            <p>Patient: <span className="font-semibold">{bookingDetails?.patientName}</span></p>
            <p>Symptoms: <span className="font-semibold">{bookingDetails?.symptoms}</span></p>
            <p>Total: <span className="font-semibold text-green-600">{bookingDetails?.total}</span></p>
          </div>
          <button
            onClick={handleConfirmationClose}
            className="mt-6 w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition duration-200 font-semibold text-sm sm:text-base"
          >
            OK
          </button>
        </Modal>
      </div>
    </div>
  );
};

export default DoctorBookingPage;